module.exports = __webpack_public_path__ + "img/power.835421ee.svg";